"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.WallCat = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _index = require("../api/index");
var WallCat = /*#__PURE__*/function () {
  function WallCat() {
    (0, _classCallCheck2["default"])(this, WallCat);
  }
  (0, _createClass2["default"])(WallCat, null, [{
    key: "getJson",
    value: function () {
      var _getJson = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var catalog,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              catalog = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'PARETI';
              if (!(WallCat.jsonData !== null)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                resolve(WallCat.jsonData);
              }));
            case 5:
              return _context.abrupt("return", WallCat.loadCatalog());
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getJson() {
        return _getJson.apply(this, arguments);
      }
      return getJson;
    }()
  }, {
    key: "loadCatalog",
    value: function () {
      var _loadCatalog = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var catalog,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              catalog = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'PARETI';
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.CrulesAPI.getWallCat(catalog, function (json) {
                  WallCat.jsonData = json;
                  resolve(WallCat.jsonData);
                }, reject);
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loadCatalog() {
        return _loadCatalog.apply(this, arguments);
      }
      return loadCatalog;
    }()
  }]);
  return WallCat;
}();
exports.WallCat = WallCat;
WallCat.jsonData = null;
//# sourceMappingURL=WallCat.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/WallCat.js
// module id = 1261
// module chunks = 142